export default __webpack_public_path__ + "static/media/Functional_Architecture_Flow_Thumnail_Image.1867d09e.png";